import * as React from "react";
import { Eye } from "lucide-react";

import type { SnapshotView } from "@/modules/snapshots/snapshotViews.types";
import { SnapshotViewPinButton } from "./SnapshotViewPinButton";

interface Props {
  view: SnapshotView;
  children?: React.ReactNode;
}

export const SnapshotViewHeader = ({ view, children }: Props) => (
  <div className="flex min-w-0 items-center gap-3">
    <SnapshotViewPinButton view={view} />
    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-orange-100 text-coral">
      <Eye className="h-5 w-5" aria-hidden="true" />
    </span>
    <div className="min-w-0">
      <h1 className="truncate text-2xl font-semibold text-[#111b35]">{view.name}</h1>
      <p className="truncate text-sm text-gray-500">
        {view.template_name ?? "Source unavailable"}
        <span className="px-1.5 text-gray-300">/</span>
        {view.snapshot_collection_name ?? "Source unavailable"}
      </p>
    </div>
    {children && <div className="ml-2 shrink-0">{children}</div>}
  </div>
);
